module.exports = __webpack_public_path__ + "static/media/media-02.c48a270e.png";